import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import {HttpHeaders} from "@angular/common/http";
import {Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {AuthService, ConfigService, StorageService} from "@cosbeni/auth";
import {FormHelperService} from "../services/form-helper.service";
import {ToasterService} from "angular2-toaster";
import {KaitoriyaConfig} from "../config/kaitoriya.config";

declare let jQuery: any;

@Component({
    selector: 'app-dashboard',
    styleUrls: ['login.component.css'],
    templateUrl: 'login.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
    account: any = {username: "", password: "", url: KaitoriyaConfig.DATABASE_URL, database: {name: KaitoriyaConfig.DATABASE}};
    version: string = KaitoriyaConfig.VERSION;
    form: FormGroup;

    constructor(public store: Store<any>,
                public router: Router,
                public formHelper: FormHelperService,
                public formBuilder: FormBuilder,
                public auth: AuthService,
                public config: ConfigService,
                public storage: StorageService,
                public toasterService: ToasterService) {
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)]),
            password: new FormControl('', [Validators.required, Validators.minLength(3)]),
        })
    }

    login(value: any) {
        let data = jQuery.param({grant_type: 'password', username: value.username, password: value.password});
        this.storage.set(this.account.database.name + "_url", this.account.url, "");
        this.storage.set("database", this.account.database.name, "");
        this.config.setTokenPrefix(this.account.database.name);
        this.auth.login(data, this.account.url + '/token/' + this.account.database.name, {headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')})
            .subscribe(response => {
                    console.log("Login");
                    this.router.navigate(["user/order"], {})
                },
                err => {
                    this.toasterService.pop("error", "ログインに失敗しました", "ユーザ名、パスワードを再度ご確認下さい。")
                },
            );
    }

}
